import React, { useState } from "react";
import { BsInfoCircle } from "react-icons/bs";
import ReactCountryFlag from "react-country-flag";
import { images } from "../../constants/index";
import moment from "moment";
import { Link } from "react-router-dom";
import ProgressiveImg from "components/progressiveImage/progressiveImg";

const Card = ({
  image,
  trip,
  tripPackage,
  country,
  startDate,
  endDate,
  flag,
  price,
  available,
  promotions,
  className,
  handleWishlist,
  landing,
  details,
  containerClass,
  inWishlist,
  accountType,
}) => {
  const accType = sessionStorage.getItem("account_type");
  const [wishIcon, setWishIcon] = useState(false);

  const [compare, setCompare] = useState(true);

  const userToken = sessionStorage.getItem("token");

  function addToWishlist() {
    handleWishlist();
    setCompare(false);
    setWishIcon(!wishIcon);
  }

  function initialClick() {
    handleWishlist();
    setCompare(false);
  }

  return (
    <div
      className={`w-full min-w-[250px] max-w-[300px]  rounded-16  ${containerClass} transition-all relative`}
    >
      {(!landing || userToken) && (
        <>
          {wishIcon ? (
            <div
              onClick={addToWishlist}
              id="wishlist-icon"
              className="cursor-pointer font-medium bg-white-100 z-10 p-2 rounded-100 w-10 h-10 text-center absolute top-52 left-2 shadow-sm"
            >
              <img src={images.like} alt="" srcSet="" />
            </div>
          ) : (
            <div
              onClick={addToWishlist}
              id="wishlist-icon"
              className=" cursor-pointer font-medium bg-white-100 z-10 p-2 rounded-100 w-10 h-10 text-center absolute top-52 left-2 shadow-sm"
            >
              <img src={images.unlike} alt="" srcSet="" />
            </div>
          )}

          {inWishlist && compare && (
            <div
              onClick={initialClick}
              id="wishlist-icon"
              className="cursor-pointer font-medium bg-white-100 z-[11] p-3 rounded-100 w-10 h-10 text-center absolute top-52 left-2 shadow-sm"
            >
              <img src={images.like} alt="" srcSet="" />
            </div>
          )}
        </>
      )}

      <Link to={details}>
        <div className="">
          <div
            className={`relative rounded-t-[8px] overflow-hidden ${className}`}
          >
            <div className="zoom-img">
              <ProgressiveImg
                src={`${image
                  ?.replace("jpg", "webp")
                  .replace("upload", "upload/w_600,h_500")}`}
                placeholderSrc={images.newyork}
                className="h-[264px] w-full object-cover rounded-t-[8px] hover:rounded-t-[8px] "
                alt=""
              />
            </div>

            {!available && (
              <div className="text-green-100 font-medium bg-white-100 text-xs  p-2 rounded-100 w-48 text-center absolute bottom-28 left-28 shadow-btn ">
                🚨 This trip is coming soon
              </div>
            )}

            {promotions && (
              <div className="text-green-100 font-medium bg-white-100 text-xs  p-2 rounded-100 w-24 text-center absolute bottom-28 left-33 shadow-btn">
                💝 {promotions}
              </div>
            )}
          </div>

          <div className="rounded-b-[8px] bg-[#F5F7F9] py-4 h-fit pl-4 text-left">
            {trip && (
              <div className="flex text-xl lg:text-2xl gap-4 text-blue-200 font-medium ">
                <BsInfoCircle className="w-5 my-1 font-bold" /> {trip}
              </div>
            )}

            {tripPackage && (
              <div className="w-full text-[20px] text-blue-200 font-medium flex-wrap ">
                <span className="">{tripPackage}</span>{" "}
                <span className="">
                  {<ReactCountryFlag countryCode={flag} svg />}
                </span>
              </div>
            )}

            {price && (
              <div className="mt-[8px] text-[21px] text-[#093549] font-bold flex flex-wrap items-center">
                ${price}
                <span className="font-medium text-[16px] whitespace-pre">
                  {" "}
                  {price ? "(Best Price Offer)" : ""}
                </span>
              </div>
            )}

            {startDate && endDate && (
              <div className="flex mt-2 text-base text-[#667085] font-bold">
                {moment(startDate).format("ll")} -{" "}
                {moment(endDate).format("ll")}
              </div>
            )}
          </div>
        </div>{" "}
      </Link>
    </div>
  );
};

export { Card };
